import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskGetGtNetLinkService } from "./task-get-gt-net-link.service";
import { TaskQuarterYearEmailSent } from './task-quarter-year-email-sent.service';
import { TaskSyncReserveWithGtNetService } from './task-sync-reserve-with-gtnet.service';
import { TaskGetSentEmailLogsService } from './task-get-sent-email-logs.service';
import { TaskGetGtNetDocumentsService } from './task-get-gtnet-documents.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    TaskGetGtNetDocumentsService,
    TaskSyncReserveWithGtNetService,
    TaskGetGtNetLinkService,
    TaskQuarterYearEmailSent,
    TaskGetSentEmailLogsService
  ],
})
export class TasksModule {}
